<template>
  <div class="app-container">
    <header class="header">
      <div class="header-top">
        <div class="pn header-top-contain">
          <div class="logo" @click="$router.push('/home')">
            <div class="img">
              <img :src="require('@/assets/layoutHome/header-logo.png')" height="38" />
            </div>
          </div>
          <div class="top-right">
            <img style="width: 456px;height: 34px;margin-right: 96px" @error="setDefaultImage"
              :src="require('@/assets/layoutHome/header-top-text.png')" height="88">
            <div class="handle" v-if="path != 'login' && path != 'register'">
              <template v-if="!hasTaken">
                <el-button type="primary" round class="login" @click="$router.push('/login')">登录
                </el-button>
                <el-button type="primary" round @click="$router.push('/register')">注册
                </el-button>
              </template>
              <div class="user" v-else>
                <div class="photo">
                  <img :src="avatarPhoto" width="36" height="36" v-if="avatarPhoto" />
                  <img v-else :src="require('@/assets/img/center/neutral.png')" width="36" height="36" />
                </div>
                <div class="user-menu">
                  <el-dropdown @command="handleCommand" placement="top-end">
                    <span v-if="hasChildAccount" class="el-dropdown-link" style="color: white;font-size: 20px">
                      {{ mainAccountInfo.nickName + '-' }} <div style="display: inline-block;font-size: 16px;">{{ name +
                        '(孩子)' }}
                      </div><i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <span v-else class="el-dropdown-link" style="color: white;font-size: 20px">
                      {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="center">个人中心</el-dropdown-item>
                      <el-dropdown-item command="switch">切换机构/角色</el-dropdown-item>
                      <el-dropdown-item command="switchUser">切换用户</el-dropdown-item>
                      <el-dropdown-item command="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner">
        <el-carousel :interval="5000" arrow="hover" height="400px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <div class="banner-item" @click="handleBannerClick(item)" style="cursor: pointer;">
              <img :src="item.image" class="img-bg" style="width: 100%; height: 100%" />
              <div class="des">
                <!-- <pre class="tit">{{ item.title }}</pre>
                <div class="txt">{{ item.text }}</div> -->
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="header-bottom">
        <div class="pn">
          <nav v-if="path !== 'login' && path !== 'register'">
            <a :class="['nav-item', path === item.key ? 'cur' : '']" v-for="(item, index) in navList" :key="index"
              @click="navto(item)">
              {{ item.label }}
            </a>
          </nav>
        </div>

      </div>
    </header>
    <keep-alive>
      <div class="main-contain">
        <router-view :section="section" @update-nav-list="updateNavList"></router-view>
      </div>
    </keep-alive>
    <Footer />
    <!--  切换角色  -->
    <selRoleLogin :open.sync=selRoleLoginVisible switch-mode="all" @roleLoginClose="selRoleLoginVisible = false">
    </selRoleLogin>
    <!--  手机号选择切换用户  -->
    <UserSelectDialog confirmText="切 换" :visible.sync="userVisible" :user-list="userList" @submit="handleUserSelect"
      @closed="handleClose" />
    <!--  快速定位  -->
    <el-backtop :visibility-height="100"></el-backtop>

    <div v-show="chatBoxVisible" ref="chatBoxContainer" class="chat-box-container">
      <chat-box ref="chatBox" v-model="chatBoxVisible"></chat-box>
    </div>

    <div v-show="!chatBoxVisible" ref="floatingIcon" @mousedown="onIconMouseDown" class="floating-icon">
      <img @click="openChatBox" src="../assets/layoutHome/AI-robot.png" alt="Chat Icon" />
    </div>

    <ChildSelectDialog confirmText="切 换" :visible.sync="childVisible" :child-list="childList"
      @submit="handleChildSelect" @closed="handleChildDialogClose" />

  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import Footer from "./footer.vue";
import selRoleLogin from "@/views/login/selRoleLogin.vue"
import { listBanner, clickSlideItem } from "@/api/home";
import debounce from 'lodash/debounce'
import ChatBox from '@/views/ai/chatView.vue';
import UserSelectDialog from "@/views/components/UserSelectDialog.vue";
import ChildSelectDialog from "@/views/components/ChildSelectDialog.vue";
import { getUsersByTel } from "@/api/login";
import { getChildListByToken } from '@/api/system/user'
import { transformParentChildData } from "@/utils/comm";

export default {
  name: "layoutPage",
  components: { UserSelectDialog, Footer, selRoleLogin, ChatBox, ChildSelectDialog },
  props: {},
  data() {
    return {
      canClick: true,
      chatBoxVisible: false,
      dragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      isDragging: false, // 新增标志位
      iconOffsetX: 0,
      iconOffsetY: 0,
      chatBoxOffsetX: 0,
      chatBoxOffsetY: 0,
      selRoleLoginVisible: false,
      section: null,
      bannerParams: {
        cmsSlideId: 10,
        // 0 PC-WEB网页，1 移动H5，2 APP-安卓，3 APP-IOS）
        deviceType: '0'
      },
      navList: [
        {
          key: "home",
          label: "首页",
        },
      ],
      path: this.$route.name,
      bannerList: [
        {
          img: require("../assets/images/home/banner1.jpg"),
          tit: "丰富教育     灵活学习",
          text: "鼓教通，提供专业化、精品化、体系化的小学教育资源服务",
        },
        {
          img: require("../assets/images/home/banner1.jpg"),
          tit: "丰富教育     灵活学习",
          text: "鼓教通，提供专业化、精品化、体系化的小学教育资源服务",
        },
      ],
      childList: [],
      childVisible: false,
      selectedUser: "",  // 选择切换的用户
      userList: [], // 用户列表
      userVisible: false, // 用户选择对话框是否可见
    };
  },
  watch: {
    $route: {
      handler: function (to) {
        console.log(to);
        this.path = to.name;
        if (to.name == "newsDetail") {
          this.path = "news";
        } else if (to.name == "appsDetail") {
          this.path = "apps";
        }
      },
      immediate: true,
      deep: true,
    },
    hasTaken: {
      handler(newVal) {
        if (newVal) {
          this.nickname = this.name;
        } else {
          this.nickname = null;
        }
      },
      immediate: true,
    },
  },
  computed: {
    // path() {
    //   console.log(this.$route.name);
    //   return this.$route.name;
    // },
    hasTaken() {
      if (getToken()) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(["name", "avatar", "phonenumber", "hasChildAccount", "mainAccountInfo"]),
    avatarPhoto() {
      return this.avatar
        ? process.env.VUE_APP_BASE_API +
        "/system/File/downOssFile?uuid=" +
        this.avatar
        : null;
    },
  },
  created() {
    this.init();
    // 使用 lodash 的 debounce 对轮播点击做防抖
    this.handleBannerClick = debounce(this._handleBannerClick, 800)
  },
  mounted() {
  },
  methods: {
    async init() {
      await this.getBanner();
    },
    async getBanner() {
      return listBanner(this.bannerParams).then((res) => {
        console.log(res);
        this.bannerList = res.data;
      });
    },
    _handleBannerClick(item) {
      console.log(item);
      // 根据不同跳转类型 adType 进行不同操作,链接是 address
      // 0 仅图片； 1 跳转网页
      if (item.adType === '0') {
        return;
      } else if (item.adType === '1') {
        // 记录点击量
        clickSlideItem(item.id).catch(() => {
          console.log('记录点击量失败');
          return;
        }).finally(() => {
          window.open(item.address, '_blank');
        });
      }
    },
    openChatBox() {
      if (this.canClick) {
        this.chatBoxVisible = true;
      }
    },
    navto(item) {
      console.log("navto", item)
      switch (item.key) {
        case 'aboutUs':
          this.$router.push("/" + item.key);
          break;
        default:
          console.log("描点", item.key);
          this.path = item.key;
          this.sendDataToHome(item.key);
          break;
      }

    },
    logout() {
      this.$confirm("确定要退出平台吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("LogOut")
          .then(() => {
            this.$router.push("/login");
            //location.href = "/";
          })
          .catch(() => { });
      });
    },
    handleCommand(command) {

      if (command === "logout") {
        this.logout();
      } else if (command === "switch") {
        if (this.hasChildAccount) {
          return this.$message({
            message: `当前暂无其他角色`,
            type: "warning",
            duration: 3000,
            showClose: true,
          })
        }
        if (this.$store.state.user.allRoles.length === 1 && this.$store.state.user.roleList.length === 1) {
          let loginRole = sessionStorage.getItem('loginRoleName') || this.$store.state.user.allRoles[0]?.roleName;
          this.$message({
            message: `当前只有一个角色【${loginRole}】，无需切换！`, // 动态显示角色名称
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        } else {
          this.selRoleLoginVisible = true
        }

        // this.$router.push({ path: "/sel", query: { switchMode: 'all' } }).catch(() => {});
      } else if (command === "switchUser") {
        let testPhoneNumber = this.phonenumber
        if (this.hasChildAccount && this.mainAccountInfo) {
          testPhoneNumber = this.mainAccountInfo.phonenumber
        }
        // 获取用户是否有用户列表
        if (!testPhoneNumber || !(/^1[3-9]\d{9}$/.test(testPhoneNumber))) {
          return this.$message({
            message: "暂无其他账号！",
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        }
        getUsersByTel({ phoneNumber: testPhoneNumber }).then((phoneRes) => {
          if (phoneRes.code === 200) {
            const userList = transformParentChildData(phoneRes.data)

            if (userList.length > 1) {
              this.userList = userList;
              this.userVisible = true;
            } else {
              this.$message({
                message: "暂无其他账号！",
                type: "warning",
                duration: 3000, // 提示显示时长
                showClose: true, // 显示关闭按钮
                iconClass: "el-icon-info", // 添加图标
              });
            }
          }
        })
          .catch((error) => {
            console.log("getUsersByTel-error", error);
          });
      } else if (command === "switchChild") {
        this.getChildList();
      } else {
        this.$router.push("/" + command);
      }
    },
    sendDataToHome(section) {
      // 不做路由跳转，只更新传递给子组件的数据
      this.section = section;
    },
    updateNavList(newNavList) {
      this.navList = newNavList;
    },
    setDefaultImage(event) {
      event.target.src = require('@/assets/layoutHome/person.png');
    },
    onIconMouseDown(event) {
      // 阻止浏览器默认拖动行为
      event.preventDefault();

      this.startX = event.clientX;
      this.startY = event.clientY;

      const iconRect = this.$refs.floatingIcon.getBoundingClientRect();
      this.iconOffsetX = event.clientX - iconRect.left;
      this.iconOffsetY = event.clientY - iconRect.top;

      // 开始拖动
      this.dragging = true;
      this.canClick = true;
      this.isDragging = true;  // 设置标志位

      // 设置拖动时的光标样式
      document.body.style.cursor = 'move';

      // 监听鼠标移动和鼠标松开
      document.addEventListener("mousemove", this.onIconMouseMove);
      document.addEventListener("mouseup", this.onIconMouseUp);
    },
    // 处理聊天图标的鼠标移动事件
    onIconMouseMove(event) {
      if (this.dragging) {
        const moveX = Math.abs(event.clientX - this.startX);
        const moveY = Math.abs(event.clientY - this.startY);
        if (moveX > 5 || moveY > 5) {
          this.canClick = false;
        }

        // 计算浮动图标的新位置
        let newTop = event.clientY - this.iconOffsetY;
        let newLeft = event.clientX - this.iconOffsetX;

        // 获取页面的宽高
        const screenHeight = window.innerHeight;
        const screenWidth = window.innerWidth;

        // 限制浮动图标的最大和最小位置
        // 让图标保持在屏幕范围内
        const minTop = 100;
        const maxTop = screenHeight - this.$refs.floatingIcon.offsetHeight - 100;
        const minLeft = 100;
        const maxLeft = screenWidth - this.$refs.floatingIcon.offsetWidth - 150;

        // 限制浮动图标的 top 和 left 不超出页面范围
        newTop = Math.max(minTop, Math.min(newTop, maxTop));
        newLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));

        this.$refs.floatingIcon.style.left = `${newLeft}px`;
        this.$refs.floatingIcon.style.top = `${newTop}px`;
      }
    },
    onIconMouseUp(event) {
      event.stopPropagation();

      // 停止拖动
      this.dragging = false;
      this.isDragging = false; // 停止拖动时，重置标志位
      document.removeEventListener("mousemove", this.onIconMouseMove);
      document.removeEventListener("mouseup", this.onIconMouseUp);

      // 恢复光标样式
      document.body.style.cursor = 'auto';
    },
    handleClose() {
      this.resetSelectUser();
    },
    handleUserSelect(user) {
      this.selectedUser = user;
      // 切换用户实现
      let changeUserRequestBody = {
        phoneNumber: this.phonenumber,
        studentUserId: this.selectedUser.childId || null,
        userName: this.selectedUser.userName
      }
      const loading = this.$loading({
        lock: true,
        text: '切换中~',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store
        .dispatch("reLoginUser", changeUserRequestBody)
        .then(() => {
          // 显示提示
          this.$message({
            message: "切换用户成功！",
            type: "success",
            duration: 1500, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-success", // 添加图标
          });
          // 刷新页面
          window.location.reload();
        })
        .catch(() => {
        })
        .finally(() => {
          loading.close();
        })
    },
    getChildList() {
      getChildListByToken().then((res) => {
        if (res.code === 200 && res.data.length > 1) {
          this.childList = res.data;
          this.childVisible = true;
        } else {
          this.$message({
            message: "暂无可切换的孩子！",
            type: "warning",
            duration: 3000,
            showClose: true,
            iconClass: "el-icon-info",
          });
        }
      });
    },
    handleChildSelect(child) {
      this.handleUserSelect(child);
      this.childVisible = false;
    },
    handleChildDialogClose() {
      this.childVisible = false;
    },
  },
};
</script>
<style scoped>
header {
  /* height: 64px; */
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  flex-direction: column;
  /* padding: 0 80px 0 200px; */
  /* padding: 0 80px; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  top: 0;
  z-index: 10;
  box-sizing: border-box;
  white-space: nowrap;
  box-shadow: 0 0 5px 0 #8b8b8b5f;
}

header .logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

header .logo .img {
  width: 251px;
  height: 88px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

header .logo .txt {
  font-size: 18px;
  color: #101010;
  font-family: Source Han Sans;
  font-weight: 500;
}

nav {
  display: flex;
  align-items: center;
  margin-left: 10%;
  justify-content: space-between;
  flex: 1;
}

.nav-item {
  margin-right: 54px;
  cursor: pointer;
}

.login.el-button--primary {
  background: #e2ecff;
  border-color: #e2ecff;
  color: rgba(37, 37, 37, 0.9);
}

.nav-item {
  margin-right: 54px;
  display: inline-block;
  height: 100%;
  line-height: 56px;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  font-weight: 400;
}

.nav-item.cur {
  font-weight: 700;
  font-size: 24px;
  color: white;
}

.nav-item::before {
  content: "";
  display: inline-block;
  border-bottom: 3px solid white;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%) scaleX(0);
  transition: 0.2s ease-in-out;
  opacity: 0;
}

.nav-item.cur::before,
.nav-item:hover::before {
  opacity: 1;
  transform: translate(-50%) scaleX(0.5);
}

.main-contain {
  min-height: calc(100vh - 296px);
  /* margin-top: 64px; */
}

.user {
  display: flex;
  align-items: center;
}

.user .photo {
  margin-right: 6.7px;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  overflow: hidden;
}

.user .user-menu-item {
  margin-left: 10px;
  cursor: pointer;
  color: #076bf2;
}

.header-top {
  height: 88px;
  align-items: center;
  display: flex;
  width: 100%;
  background: url("@/assets/layoutHome/header-top.png");
  background-size: cover;
}

.header-top-contain {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.top-right {
  display: flex;
  align-items: center;
}

.header-bottom {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  background-color: #076BF2A3;
  color: white;
}

.banner {
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.banner-item {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.banner-item .img-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.banner-item .des {
  margin-left: 20vw;
  color: #282828;
}

.banner-item .des .tit {
  font-size: 36px;
  font-weight: 500;
  line-height: 36px;
  font-family: "Microsoft YaHei";
}

.banner-item .des .txt {
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  margin-top: 24px;
}

::v-deep .el-backtop {
  position: fixed;
  right: 20px;
  bottom: 20px;
}

.floating-icon {
  position: fixed;
  bottom: 100px;
  right: 164px;
  cursor: pointer;
  z-index: 2000;
  min-width: 50px;
  min-height: 50px;
  max-width: 196px;
  max-height: 199px;
}

.floating-icon img {
  min-width: 50px;
  min-height: 50px;
  max-width: 196px;
  max-height: 199px;
}

.chat-box-container {
  position: fixed;
  bottom: 30% !important;
  right: 20px;
  z-index: 9998;
}

.chat-box {
  width: 300px;
  height: 400px;
  background-color: #fff;
}

.el-dropdown-menu {
  padding: 12px 0;
  text-align: center;
  min-width: 200px;
  line-height: 40px;
}

.el-dropdown-menu__item {
  font-size: 24px !important;
  padding: 12px 20px;
  margin: 12px 0 !important;
}
</style>
